export default {
    name: {
        label: 'Name',
        placeholder: 'Name',
    },
    id: {
        label: 'Id',
    },
    exportFormat: {
        label: 'Export format',
        placeholder: 'Export format',
    },
    exportType: {
        label: 'Export type',
        placeholder: 'Export type',
    },
    save: 'Save',
    cancel: 'Cancel',
    title: {
        update: 'Update file',
    },
    button: {
        save: 'Save',
        create: 'Create',
        edit: 'Edit',
        delete: 'Delete',
        upload: 'Upload',
        synthesis: 'Synthesis',
        delegate: 'Delegate',
    },
    error: {
        invalidFileName:
            'The file name should contain only alphabets, numbers, spaces, dot, underscore and dash',
    },
    success: {
        update: 'The file name has been updated',
        delete: 'The file has been deleted',
    },
    delete: {
        confirm: {
            title: 'Delete file',
            message: 'Are you sure to delete this file?',
        },
    },
};
